import amplitude from 'amplitude-js'

import { AmplitudeDeviceType } from '@brighterly/lib-core-types/tools/amplitude/enums'

const getUADeviceType = (): AmplitudeDeviceType => (useDevice().isDesktop && !useDevice().isMobile)
  ? AmplitudeDeviceType.Desktop
  : AmplitudeDeviceType.Mobile

export const getDeviceType = (ua = null): AmplitudeDeviceType => {
  // @ts-expect-error isolated type _ua
  const info = ua || amplitude.getInstance()._ua
  const type = `${info.device.type}`.trim().toLowerCase()
  const os = `${info.os.name}`.trim().toLowerCase()
  const isDesktop = (type === AmplitudeDeviceType.Desktop) || (os === AmplitudeDeviceType.ChromiumOS)
  const isMobile = (type === AmplitudeDeviceType.Mobile && os !== AmplitudeDeviceType.ChromiumOS)
    || (type === AmplitudeDeviceType.Tablet && os !== AmplitudeDeviceType.ChromiumOS)

  return isDesktop
    ? AmplitudeDeviceType.Desktop
    : isMobile
      ? AmplitudeDeviceType.Mobile
      : getUADeviceType()
}
